import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { baseApi } from '@platform/state/api';
import { useAppDispatch } from '@platform/state/hooks';
import { workspaceSelected } from '@platform/state/slices/sessionSlice';

/**
 * Перехід у застосунок після зміни особи (вхід, реєстрація, вихід, спостерігач): увесь кеш API скидається — дані попередньої особи не
 * лишаються, — поточний робочий простір вкладки теж (ADR-028: оболонка вибере простір входу — власний офіс депутата, інакше перший простір;
 * `workspaceId` — простір, який відкрити одразу, як демо-офіс спостерігача), і відкривається вказаний маршрут (із заміною запису історії).
 */
export function useEnterApp(): (to: string, state?: unknown, workspaceId?: string | null) => void {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  return useCallback((to: string, state?: unknown, workspaceId?: string | null) => {
    dispatch(baseApi.util.resetApiState());
    dispatch(workspaceSelected(workspaceId ?? null));
    navigate(to, { replace: true, state });
  }, [dispatch, navigate]);
}
